import { Issue, KioskPublicationCategory } from "@/stores/types";
import { Box, Grid, Typography } from "@mui/material";
import IssueItem from "./IssueItem";
import { useMemo } from "react";

type KioskPublicationSectionProps = {
  category: KioskPublicationCategory;
  onPressIssue?: (issue: Issue) => any;
  maxItems?: number;
  withTitle?: boolean;
};

const KioskPublicationSection = (props: KioskPublicationSectionProps) => {
  const { category, onPressIssue, maxItems, withTitle = false } = props;

  const title = useMemo(() => {
    if (withTitle) {
      return (
        <Typography
          variant={"h4"}
          sx={{
            my: 2,
            // color: (t) =>
            //   t.palette.mode === "light"
            //     ? t.palette.common.black
            //     : t.palette.common.white,
          }}
        >
          {category.name}
        </Typography>
      );
    }
    return null;
  }, [withTitle, category]);
  return (
    <Box>
      {title}

      <Grid
        container
        columnSpacing={2}
        rowSpacing={3}
        direction="row"
        justifyContent="flex-start"
        alignItems="stretch"
      >
        {category.items.map((item, i) => {
          if (maxItems && i + 1 > maxItems) {
            return null;
          }
          const { publicationNumber } = item;
          return (
            <Grid key={i} item xs={6} sm={3} md={4}>
              <IssueItem
                title={item.name}
                image={publicationNumber?.coverUrl!}
                publishedAt={publicationNumber?.dateParution}
                onClick={
                  onPressIssue && publicationNumber
                    ? () => onPressIssue(publicationNumber)
                    : undefined
                }
              />
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};
export default KioskPublicationSection;
